/**
 * Handle Amplify auth Hub events and synchronize localStorage state.
 *
 * This keeps the login state consistent for both the application and E2E tests.
 *
 * @param {{ event?: string, data?: { username?: string, attributes?: { email?: string } } }} payload
 */
export function handleAuthEvent(payload) {
  if (!payload || !payload.event) {
    return;
  }

  if (payload.event === 'signIn') {
    const email = payload.data && payload.data.attributes ? payload.data.attributes.email : undefined;
    const username = payload.data ? payload.data.username : undefined;

    localStorage.setItem('hasBeenLoggedIn', 'signin');

    if (email) {
      localStorage.setItem('user', email);
    }

    if (username) {
      localStorage.setItem('username', username);
    }

    return;
  }

  if (payload.event === 'signOut') {
    localStorage.removeItem('hasBeenLoggedIn');
    localStorage.removeItem('user');
    localStorage.removeItem('username');
  }
}
